<template>
  <div style="width: 700px">
    <el-row>
      <el-col :span="24">
        <el-card class="box-card" style="width: 750px; margin: 0px auto;">
          <div slot="header" class="clearfix">
            <span>报价器-lol手游(国服)</span>
          </div>
          <el-tabs v-model="activeType" type="card" @tab-click="tabSelect">
            <el-tab-pane label="段位代练" name="Dan">
              <div>
                <el-row>
                  <el-col :span="12">
                    <dan v-for="(item,index) in dans"
                         :key="index"
                         :data="item"
                         :selectedDans="selectedDans"
                         @selected="handleSelected"/>
                  </el-col>
                  <el-col :span="12">
                    <el-form ref="form" label-width="50px" label-position="left">
                      <el-form-item label="区服">
                        <el-radio-group v-model="zone" size="mini">
                          <el-radio-button border label="ANDRIOD">安卓</el-radio-button>
                          <el-radio-button border label="IOS">IOS</el-radio-button>
                        </el-radio-group>
                        <el-radio-group v-model="server" size="mini" style="margin-left: 10px;">
                          <el-radio-button border label="QQ">QQ</el-radio-button>
                          <el-radio-button border label="WECHAT">微信</el-radio-button>
                        </el-radio-group>
                      </el-form-item>
                      <el-form-item label="起始">
                        {{starCount.startStar.label}}
                        <span :class="startStarCountClass" v-if="selectedDans[0]!=undefined && selectedDans[0].starCount>0">
                        <el-input-number size="mini" v-model="starCount.startStar.count" style="width: 100px;"
                                         ref="startStarCount" ></el-input-number>
                        {{zuan(selectedDans[0].id)}}
                        </span>
                        <el-rate v-if="selectedDans[0]!=undefined && selectedDans[0].starCount>0 && selectedDans[0].id<7" v-model="starCount.startStar.count"
                                 :max="selectedDans[0]==null?5:selectedDans[0].starCount"
                                 style="float: right;line-height: 50px;padding-right: 20px;"></el-rate>
                      </el-form-item>

                      <el-form-item label="结束">
                        {{starCount.endStar.label}}
                          <span :class="endStarCountClass" v-if="selectedDans[1]!=undefined && selectedDans[1].starCount>0">
                               <el-input-number size="mini" v-model="starCount.endStar.count" style="width: 100px;"
                                                ref="endStarCount" ></el-input-number>
                          {{zuan(selectedDans[1].id)}}
                          </span>
                        <el-rate v-if="selectedDans[1]!=undefined && selectedDans[1].starCount>0 && selectedDans[1].id<7" v-model="starCount.endStar.count"
                                 :max="selectedDans[1]==null?5:selectedDans[1].starCount"
                                 style="float: right;line-height: 50px;padding-right: 20px;"></el-rate>
                      </el-form-item>
                      <el-form-item label="折扣">
                        <el-radio-group v-model="discount" size="mini">
                          <el-radio-button border
                                           v-for="(item, index) in discounts" :key="index"
                                           :label="item.discount">{{item.name}}
                          </el-radio-button>
                        </el-radio-group>
                      </el-form-item>

                    </el-form>
                  </el-col>
                </el-row>

              </div>
            </el-tab-pane>
          </el-tabs>
          <div>
            <el-row>
              <el-col :span="24">
                <div style="float: right">
                  <el-button type="primary" @click="genPrice" style="margin-left: 5px" class="btnGen" id="btnGen"
                             ref="btnGen">生成报价
                  </el-button>
                  <el-button type="primary" @click="gokTotalPrice" style="margin-left: 5px" class="btnGen">整单优惠
                  </el-button>
                  <el-button id="btnCopy" v-clipboard:copy="content" v-clipboard:success="onCopy"
                             v-clipboard:error="onError" ref="btnCopy">复制报价
                  </el-button>
                  <el-button @click="reset" id="btnReset">重置查询</el-button>
                </div>
              </el-col>
            </el-row>
            <el-row style="margin-top: 10px">
              <el-col :span="24">
                <el-input type="textarea" :row="5" placeholder="报价内容" v-model="content"
                          :autosize="{ minRows: 3, maxRows: 10}"></el-input>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <div style="margin-top: 10px;margin-left:10px;text-align: center;">
      <el-alert
        title="空格键=生成报价+复制报价,回车键=复制报价!"
        type="success"
        center
        show-icon>
      </el-alert>
    </div>

  </div>
</template>

<script>
  import Dan from '../components/mGFLOLDan'

  export default {
    name: 'mgflol',
    components: {  Dan },
    data () {
      return {
        gameId: 100,
        dans: this.$store.state.mGFlolDans,
        selectedDans: [],
        zone: 'ANDRIOD',
        server: 'QQ',
        inscriptionId: 0,
        inscriptions: [],
        showEstimateTime: true,
        content: '',
        activeType: 'Dan',
        prompt: true,
        discountType: 'NORMAL',
        starCount: {
          startStar: {
            label: '起始',
            count: 0
          },
          endStar: {
            label: '结束',
            count: 0
          },
          keyNum: 1
        },
        keyStar: true,
        startStarCountClass: {},
        endStarCountClass: {},
        keyValue: {},
        keyKingValue: '',
        oldDan: [],
        isKeyDan: true,
        showFirstDan: true,
        pricingTypeId:1,
        pricingId: 'GOK_LEVELING',
        danStar:0,
        //折扣
        discount:'1',
        discounts:[]
      }
    },

    mounted () {
      this.loadInscriptions()
      this.getDiscount()
      this.loadQuoterTextFormat()
      this.enterKeyup()
    },
    computed: {
      sortedSelectedDans () {
        let target = []

        Object.assign(target, this.selectedDans)
        target.sort((x, y) => {
          let xDanIndex = this.dans.findIndex((i) => {
            return i.name === x.dan
          })
          let yDanIndex = this.dans.findIndex((i) => {
            return i.name === y.dan
          })

          return xDanIndex - yDanIndex
        })

        return target
      }
    },
    methods: {
      loadInscriptions () {
        let url = '/api/company/inscriptions?gameId=' + this.gameId + '&pricingType=' + this.pricingId
        this.$http.get(url).then(res => {
          this.inscriptions = res.data
          if (this.inscriptions.length > 0) {
            this.inscriptionId = this.inscriptions[0].id
          }
        })
      },
      loadQuoterTextFormat () {
        let url = '/api/company/format?gameId=' + this.gameId + '&pricingType=' + this.pricingId
        this.$http.get(url).then(res => {
          let data = res.data

          if (data != null) {
            this.showEstimateTime = data.showEstimateTime
          }
        })
      },
      handleSelected (value) {
        let index = this.selectedDans.findIndex((x) => {
          return x.dan === value.dan && x.subDan === value.subDan
        })
        if (index === -1) {
          if (this.selectedDans.length === 2) {
            this.selectedDans.splice(0, 1)
          }
          this.selectedDans.push(value)
        } else {
          this.selectedDans.splice(index, 1)
        }
        //段位判断
        this.keyValue = value
        this.keyKingValue = ''
        this.setDan()

      },
      setDan () {
        if (this.selectedDans.length == 1) {
          this.selectedDans.push(this.selectedDans[0])
        }

        this.compareDans()
        this.compareDansLevel()
        this.setStarCount()
        if (this.keyValue.label == this.starCount.startStar.label && this.keyValue.level != 6) {

          this.startStarCountClass = { active: 'active' }
          this.endStarCountClass = {}


        } else if (this.selectedDans.length > 1 && this.keyValue.label == this.starCount.endStar.label && this.keyValue.level != 6) {
          this.endStarCountClass = { active: 'active' }

          this.startStarCountClass = {}
        }

      },
      //同段位判断
      compareDans () {
        if (this.selectedDans.length < 2) {
          return
        }

        if (this.selectedDans[0].dan == this.selectedDans[1].dan) {
          if (this.selectedDans[0].subDan < this.selectedDans[1].subDan) {
            //解构赋值
            this.selectedDans = [this.selectedDans[1], this.selectedDans[0]]
          }
        }
      },
      //等级判断
      compareDansLevel () {
        if (this.selectedDans.length < 2) {
          return
        }
        if (this.selectedDans[0].id > this.selectedDans[1].id) {
          //解构赋值
          this.selectedDans = [this.selectedDans[1], this.selectedDans[0]]
        }
      },
      setStarCount () {
        this.starCount.startStar.label = this.selectedDans[0].label
        if(this.starCount.startStar.id==7 || this.starCount.startStar.id==8){
          this.starCount.startStar.count = 0
        }else{
          this.starCount.startStar.count = this.selectedDans[0].count
        }

        this.starCount.endStar.label = this.selectedDans[1].label
        if(this.starCount.endStar.id==7 || this.starCount.endStar.id==8){
          this.starCount.endStar.count = 0
        }else{
          this.starCount.endStar.count = this.selectedDans[1].count
        }
      },
      formatSubDan (subDan) {
        if (subDan === 'A' || subDan === 'B') {
          subDan = ''
        }
        return subDan
      },
      genPrice (event) {
        let that = this
        that.isKeyDan = true
        this.discountType = 'NORMAL'
        if (that.activeType === 'Dan' || that.activeType === 'PartnerDan') {
          that.gokDanPrice()
        } else if (that.activeType === 'Battle') {

          that.gokBattlePrice()
        } else if (that.activeType === 'Summit') {

          that.gokSummitPrice()
        }
      },
      // 代练报价
      gokDanPrice () {
        let that = this
        if (that.sortedSelectedDans.length == 0 && that.activeType === 'Dan') {
          this.$message('请选择段位！')
          return false
        }
        let startDan = that.sortedSelectedDans[0].label
        let thatEndDan = 0
        if (that.sortedSelectedDans.length == 1) {
          thatEndDan = that.sortedSelectedDans[0].label
        } else {
          thatEndDan = that.sortedSelectedDans[1].label
        }
        let data = {
          gameId: this.gameId,
          discountType: this.discountType,
          zone: this.zone,
          server: this.server,
          fromDan: startDan,
          fromPoint: this.starCount.startStar.count,
          toDan: thatEndDan,
          toPoint: this.starCount.endStar.count,
          inscriptionId: this.inscriptionId,
          showTime: this.showEstimateTime,
          showFirstDan: this.showFirstDan,
          pricingTypeId: this.pricingTypeId,
          discount:this.discount
        }

        this.$http.post('/api/lolm-gf/price/dan', data).then((res) => {
          if (res == null) {
            return
          }
          that.content = res.data
          that.doCopy(this.content)
          that.$message('代练报价生成成功！')
        })
      },
      //整单优惠报价
      gokTotalPrice () {
        let that = this
        this.discountType = 'TOTAL'
        if (that.activeType === 'Dan' || that.activeType === 'PartnerDan') {
          that.gokDanPrice()
        } else if (that.activeType === 'Battle') {
          that.gokBattlePrice()
        } else if (that.activeType === 'Summit') {
          that.gokSummitPrice()
        }
      },
      // 战力报价
      gokBattlePrice () {
        let that = this
        let from = that.$refs['fromBattle'].fromBattle
        let data = {
          fromPoint: from.fromPoint,
          discountType: this.discountType,
          gameId: that.gameId,
          inscriptionId: from.inscriptionId,
          showTime: from.showTime,
          toPoint: from.toPoint,
          discount:from.discount
        }
        this.$http.post('/api/gok/price/battle', data).then((res) => {
          if (res == null) {
            return
          }
          this.content = res.data
          this.doCopy(this.content)
          this.$message('战力报价生成成功！')
        })
      },
      // 巅峰赛报价
      gokSummitPrice () {
        let that = this
        let from = that.$refs['fromSummit'].fromSummit
        let data = {
          fromPoint: from.fromPoint,
          discountType: this.discountType,
          gameId: that.gameId,
          inscriptionId: from.inscriptionId,
          showTime: from.showTime,
          toPoint: from.toPoint,
          discount:from.discount
        }
        this.$http.post('/api/gok/price/summit', data).then((res) => {
          if (res == null) {
            return
          }

          this.content = res.data
          this.doCopy(this.content)
          this.$message('巅峰报价生成成功！')

        })
      },
      reset () {
        let that = this
        if (that.activeType === 'Dan' || that.activeType == 'PartnerDan') {
          this.selectedDans = []
          this.zone = 'ANDRIOD'
          this.server = 'QQ'
          if (this.inscriptions.length > 0) {
            this.inscriptionId = this.inscriptions[0].id
          }
        } else if (that.activeType === 'Battle') {
          that.$refs['fromBattle'].fromBattle.fromPoint = ''
          if (that.$refs['fromBattle'].fromBattle.inscriptions.length > 0) {
            that.$refs['fromBattle'].fromBattle.inscriptionId = that.$refs['fromBattle'].fromBattle.inscriptions[0].id
          }
          that.$refs['fromBattle'].fromBattle.showTime = true
          that.$refs['fromBattle'].fromBattle.toPoint = ''
        } else if (that.activeType === 'Summit') {
          that.$refs['fromSummit'].fromSummit.fromPoint = ''
          if (that.$refs['fromSummit'].fromSummit.inscriptions.length > 0) {
            that.$refs['fromSummit'].fromSummit.inscriptionId = that.$refs['fromSummit'].fromSummit.inscriptions[0].id
          }
          that.$refs['fromSummit'].fromSummit.showTime = true
          that.$refs['fromSummit'].fromSummit.toPoint = ''
        }
        this.keyStar = true
        this.startStarCountClass = {}
        this.endStarCountClass = {}
        this.starCount = {
          startStar: {
            label: '起始',
            count: 1
          },
          endStar: {
            label: '结束',
            count: 1
          },
          keyNum: 1
        }
        this.keyStar = true
        this.startStarCountClass = {}
        this.endStarCountClass = {}
        this.keyValue = {}
        this.keyKingValue = ''
        this.oldDan = []
        this.isKeyDan = true
        this.$message('重置成功')
      },
      onCopy (e) {
        this.$message('内容已复制到剪切板！')
      },
      // 复制失败时的回调函数
      onError (e) {
        this.$message('抱歉，您的浏览器不支持！')
      },
      doCopy (e) {
        let that = this
        that.$copyText(this.content).then(function (e) {
          that.$message('内容已复制到剪切板')

        }, function (e) {
          if (that.prompt) {
            that.prompt = false
            that.$message('您的浏览器不支持自动复制,请点击右侧复制按钮,或下载Chrome浏览器使用！')
          }

        })
      },
      enterKeyupDestroyed () {
        document.removeEventListener('keyup', this.enterKey)
      },
      enterKeyup () {
        document.addEventListener('keyup', this.enterKey)
      },
      enterKey (event) {
        const componentName = this.$options.name
        if (componentName == 'mgflol') {
          const code = event.keyCode
            ? event.keyCode
            : event.which
              ? event.which
              : event.charCode

          switch (code) {
            case 32:
              this.$refs.btnGen.$el.focus()
              this.genPrice()
              break
            case 13:
              this.doCopy()
              break
          }
        }
      },
      showMessage (msg, duration) {
        let that = this
        that.$message({
          showClose: true,
          message: msg,
          type: 'warning',
          duration: duration
        })
      },
      changeStarCount (event) {
        //this.getDanStar()
        this.isKeyDan = false
      },
      changeEndCount (event) {
        //this.getDanStar()
        this.isKeyDan = false
      },
      tabSelect (event) {
        if (event.name == 'PartnerDan') {
          this.pricingId = 'GOK_PARTNER_LEVELING'
          this.danStar=0
          this.loadInscriptions()
          this.getDiscount()
          this.loadQuoterTextFormat()
        } else if (event.name == 'Dan') {
          this.danStar=0
          this.pricingId = 'GOK_LEVELING'
          this.loadInscriptions()
          this.getDiscount()
          this.loadQuoterTextFormat()
        }
      },
      getDanStar(){
        let that=this
        let startDan = that.sortedSelectedDans[0].label
        let thatEndDan = 0
        if (that.sortedSelectedDans.length == 1) {
          thatEndDan = that.sortedSelectedDans[0].label
        } else {
          thatEndDan = that.sortedSelectedDans[1].label
        }
        let data={
          fromDan:startDan,
          fromStarCount:this.starCount.startStar.count,
          toDan:thatEndDan,
          toStarCount:this.starCount.endStar.count
        }
        //
        // this.$http.post('/api/gok/price/dan/count',data).then(res=>{
        //   if(res!==null){
        //     that.danStar=res.data
        //   }
        // })
      },
      //获取折扣设置
      getDiscount(){
        let that=this
        that.discounts=[]
        that.discount=null
        axios.get('/api/company/discount',{params:{gameId:that.gameId,pricingType:that.pricingId}}).then(res=>{
          if(res!=null){
            that.discounts=res.data
          }
          that.discounts.unshift({name:'不打折',discount: '1'})
          that.discount='1'
        })
      },
      zuan(id){
        if(id<7){
          return '钻'
        }else{
          return '分'
        }
      }
    },
    destroyed () {
      let that = this
      that.$message.closeAll()
      that.enterKeyupDestroyed()
    },
    beforeDestroy () {
      // 销毁enter事件
      this.enterKeyupDestroyed()
    },
    activated () {
      console.log('刷新')
    },
  }
</script>

<style lang="stylus" scoped>
  .desc_text {
    height 40px;
    line-height 40px;
    margin-right 5px;
  }

  .active {
    color: rgb(247, 186, 42) !important;
  }
</style>
